export default __webpack_public_path__ + "assets/c158c98c0e3d16ef771327718528b5a8.png";